import { useEffect } from "react";
import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { HeroSection } from "@/components/sections/hero-section";
import { AboutSection } from "@/components/sections/about-section";
import { CategoriesSection } from "@/components/sections/categories-section";
import { PartnersSection } from "@/components/sections/partners-section";
import { CustomizationSection } from "@/components/sections/customization-section";
import { ContactSection } from "@/components/sections/contact-section";

const Index = () => {
  useEffect(() => {
    document.title = "AVON BEARINGS - Best Bearing Shop in Wankaner & Morbi | SKF, FAG, NBC, Timken Dealer";
  }, []);

  return (
    <div className="flex flex-col min-h-screen transition-theme">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <AboutSection />
        <CategoriesSection />
        <PartnersSection />
        <CustomizationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
